module.exports = __webpack_public_path__ + "img/23.e7ab091a.png";